module.exports = __webpack_public_path__ + "img/avatar2.e70d6b20.png";